import styled from 'styled-components';

export const FiltersWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FiltersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
`;

export const StyledFilterItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  .ant-select {
    width: 168px;
  }
  .filter-autocomplete {
    width: 240px;
    .ant-input-affix-wrapper {
      padding: 8px 11px;
      border-radius: 4px;
      border-color: ${({ theme }) => theme.colors.grayVariations.murky};
    }
  }
  .year-select {
    width: 100px;
    .ant-select-arrow {
      & > div {
        color: ${({ theme }) => theme.colors.allowedColorsToUse.primaryBlue.normal};
      }
    }
    .ant-select-selector {
      border-color: ${({ theme }) => theme.colors.allowedColorsToUse.primaryBlue.normal};
      .ant-select-selection-item {
        color: ${({ theme }) => theme.colors.allowedColorsToUse.primaryBlue.normal};
      }
    }
  }
`;
